import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { AppType } from './base/enums';
import { store } from './base/redux/store';
import { App } from './App';

import './base/assets/styles/index.scss';

interface GLOBALS {
    appType: AppType;
    route: string;
    apiToken?: string;
    language?: string;
    vacancyId?: string;
    duplicate?: boolean;
    referrer?: string;
    recaptchaSiteId?: string;
    apiBaseUrl?: string;
    crossSiteBaseUrl?: string;
    workerId?: string;
}

declare global {
    interface Window {
        GLOBALS: GLOBALS;
        toggleFavorite: (id: string | number, element: string) => void;
        dataLayer: object[];
    }
}

// eslint-disable-next-line max-len
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <Provider store={store}>
        <React.StrictMode>
            <Router>
                <App />
            </Router>
        </React.StrictMode>
    </Provider>,
);
